import React from 'react';

function LoadingSpinner({ fullScreen = false }) {
  const spinnerClass = fullScreen ? 'loading-spinner-fullscreen' : 'loading-spinner';

  return (
    <div className={spinnerClass}>
      <div className="spinner-container">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    </div>
  );
}

export default LoadingSpinner;